export default __webpack_public_path__ + "armchair.57a66b9d.svg";